/**
 * 광고 화면 구현
 */
import { SbsPlayerGlobal } from '../../../common';
import { clamp } from '../../../utils';
import { loadLocalStorage, saveLocalStorage } from '../../../utils/storage';

import SbsPlayerLogger from '../../../utils/logger';

import './AdInfoArea';
import './AdVideo';
import './Center';
import './Controls';
import './NetworkAdControls';

customElements.define(
  'sbs-player-ad-wrapper',
  class extends HTMLElement {
    constructor() {
      super();
      this.position = '';
      this.platform = {};
      this.campaign = {};
      this.sender = null;
      this.adSequenceText = '';
    }

    set position(value) {
      this._position = value;
    }

    get position() {
      return this._position;
    }

    async connectedCallback() {
      try {
        // ad-recieved 시 렌더링
        // this.render();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    ready() {
      try {
        this.dispatchEvent(new CustomEvent('ad-container-ready'));
        // 로딩 필요..
        this.innerHTML = `<div class="playerVideo_w">
        <div class="playerVideoCont">
          <video style="width: 100%;" ${
            SbsPlayerGlobal.options.muted ? 'muted' : ''
          } ${SbsPlayerGlobal.options.autoplay ? 'autoplay' : ''}></video>
        </div>
        <div class="playerADVideoCont"></div>
        <sbs-player-ad-center-buttons></sbs-player-ad-center-buttons>
      </div>
      <sbs-player-ad-sequence style="position: absolute; bottom: 0;" text=${
        this.adSequenceText
      }></sbs-player-ad-sequence>`;
        this.styles();
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
        this.style.display = 'block';
        this.style.height = '0px';

        const isFullScreenMode = document.fullscreenElement !== null;
        if (isFullScreenMode) {
          this.querySelector('video').style.height = '100vh';
        } else {
          this.querySelector('video').style.height = '100%';
        }
      } catch (error) {
        console.error(error);
      }
    }

    count(text) {
      try {
        this.adSequenceText = text;
      } catch (error) {
        console.log(error);
      }
    }

    attemptPlayback(videoElement, isMutedRetry = false) {
      console.log(
        'attemptPlayback',
        videoElement,
        isMutedRetry,
        videoElement.video.paused
      );
      if (!videoElement.video.paused) {
        return false;
      }

      if (
        isMutedRetry &&
        window.navigator.userAgent.match(
          /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
        )
      ) {
        return false;
      }

      let promise = videoElement.video.play();
      if (promise !== undefined) {
        promise
          .then((_) => {
            // 재생 성공 시 볼륨 설정
            if (!isMutedRetry) {
              console.log('자동 재생 성공');
              videoElement.video.muted = false;
              videoElement.video.volume = 0.5;
            } else {
              videoElement.video.muted = true;
              videoElement.video.volume = 0;
              videoElement.video.play();
              console.log('음소거 상태로 자동 재생 성공');
            }
          })
          .catch((error) => {
            console.warn('video play error', error);

            if (!isMutedRetry) {
              // 첫 시도 실패 시 음소거 상태로 재시도
              console.log('자동 재생 실패, 음소거 상태로 재시도합니다');
              videoElement.video.muted = true;
              videoElement.video.volume = 0;
              this.attemptPlayback(videoElement, true);
            } else {
              // 음소거 재시도도 실패한 경우
              console.warn('음소거 상태에서도 재생 실패');
              SbsPlayerGlobal.events.emitEvent('autoplay-failed');
            }
          });
      } else {
        console.log('video not loaded?');
      }
    }

    render(ads) {
      try {
        SbsPlayerGlobal.view
          .querySelector('.playerWrap')
          .classList.add('playerADType');
        this.style.opacity = 1;
        this.style.display = 'block';
        this.style.width = '100%';
        this.style.height = '100%';
        this.platform = ads.platform;
        this.campaign = ads.campaign;
        this.adSequenceText = ads.adSequenceText;

        // 보안: SBS/SMR 광고 시 네트워크 광고 컨트롤러 제거
        if (
          ads.platform &&
          (ads.platform.name === 'SBS' || ads.platform.name === 'SMR')
        ) {
          this.hideNetworkAdControls(ads.platform.name);
        }

        let isNetworkAds = this.campaign.ads === undefined;
        let mediaUrl = isNetworkAds
          ? this.campaign.getMediaUrl() || ''
          : this.campaign.ads[0].content_url;
        mediaUrl = mediaUrl.replace('http://', 'https://');
        let isLiveMidRoll = SbsPlayerGlobal.live_midroll.duration;
        this.innerHTML = `<div class="playerVideo_w">
        <div class="playerVideoCont">
          <sbs-player-ad-video src=${mediaUrl}></sbs-player-ad-video>
        </div>
        ${
          isLiveMidRoll
            ? ``
            : `<sbs-player-ad-center-buttons></sbs-player-ad-center-buttons>`
        }
      </div>
      ${
        this.campaign
          ? `<sbs-player-ad-info-area 
      duration="${
        SbsPlayerGlobal.live_midroll.duration
          ? SbsPlayerGlobal.live_midroll.duration
          : ''
      }" 
      text="${
        SbsPlayerGlobal.live_midroll.title
          ? SbsPlayerGlobal.live_midroll.title
          : ''
      }"></sbs-player-ad-info-area>`
          : ``
      }
      <sbs-player-ad-controls sequence_text=${
        this.adSequenceText
      }></sbs-player-ad-controls>`;
        this.event();
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
        const infoAreaElement = this.querySelector('sbs-player-ad-info-area');
        const videoElement = this.querySelector('sbs-player-ad-video');
        const centerElement = this.querySelector(
          'sbs-player-ad-center-buttons'
        );
        const controller = this.querySelector('sbs-player-ad-controls');
        if (this.campaign) {
          infoAreaElement.position = this.position;
          infoAreaElement.campaign = this.campaign;
          videoElement.campaign = this.campaign;

          setTimeout(() => {
            // * 재생 시도.
            this.attemptPlayback(videoElement);
          }, 750);
        }
        infoAreaElement?.addEventListener('ad-more-click', () => {
          let clickThroughUrl =
            this.campaign.ads[0].tracking_url.click ||
            this.campaign.ads[0].tracking_url.clickThrough ||
            this.campaign.ads[0].tracking_url.clickTracking ||
            this.campaign.ads.tracking_url.click ||
            this.campaign.ads.tracking_url.clickThrough ||
            this.campaign.ads.tracking_url.clickTracking;
          window.open(clickThroughUrl);
          fetch(
            this.campaign.ads[0].tracking_url.clickTracking ||
              this.campaign.ads.tracking_url.clickTracking
          );
        });
        infoAreaElement?.addEventListener('ad-skip-click', () => {
          videoElement.video.pause();
          this.dispatchEvent(new CustomEvent('ad-skip-click'));
          let skipTrackingUrl =
            this.campaign.ads[0].tracking_url.skip ||
            this.campaign.ads.tracking_url.skip;
          fetch(skipTrackingUrl);
        });
        centerElement.addEventListener('button-toggle-playpause', (event) => {
          let paused = event.detail;
          paused ? videoElement.video.play() : videoElement.video.pause();
        });
        controller.addEventListener('button-toggle-playpause', (event) => {
          let paused = event.detail;
          paused ? videoElement.video.play() : videoElement.video.pause();
        });
        controller.addEventListener('button-click-replay', (event) => {
          videoElement.video.currentTime = 0;
          videoElement.video.play();
        });
        controller.addEventListener('button-toggle-volume', (event) => {
          let muted = event.detail;
          videoElement.video.volume = muted ? 0.5 : 0;
        });
        controller.addEventListener('button-toggle-fullscreen', (event) => {
          this.dispatchEvent(
            new CustomEvent('button-toggle-fullscreen', {
              detail: event.detail,
            })
          );
        });
        controller.addEventListener('input-change-volume', (event) => {
          let value = event.detail;
          let changeVolume = value && clamp(value, 0, 1);
          videoElement.video.volume = changeVolume;
          saveLocalStorage(
            SbsPlayerGlobal.storage.sbsplayer_volume,
            changeVolume
          );
        });
        // * unmute 컴포넌트에서 발생하는 이벤트
        SbsPlayerGlobal.events.addEventListener(
          'input-change-volume',
          (volume) => {
            let changeVolume = clamp(volume, 0, 1);
            videoElement.video.volume = changeVolume;
            saveLocalStorage(
              SbsPlayerGlobal.storage.sbsplayer_volume,
              changeVolume
            );
          }
        );
        // * SBS로그모듈 - adPlay
        SbsPlayerGlobal.logModule.adPlay(this.platform, this.position);

        SbsPlayerGlobal.events.addEventListener('ad-autoplay-failed', () => {
          try {
            console.log('ad-autoplay-failed');
            centerElement.style.display = 'block';

            if (videoElement && videoElement.video) {
              videoElement.video.muted = true;
              videoElement.video.volume = 0;

              const retryPlayPromise = videoElement.video.play();
              retryPlayPromise
                .then(() => {
                  console.log('음소거 상태로 자동 재생');
                })
                .catch((error) => {
                  console.error('음소거 상태에서도 자동 재생 오류:', error);
                });
            }
          } catch (error) {
            console.log(error);
          }
        });
      } catch (error) {
        console.error(error);
      }
    }

    ended() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    // 네트워크 광고 컨트롤러 숨기기 함수
    hideNetworkAdControls(platformName) {
      try {
        const networkControls = SbsPlayerGlobal.view.querySelector(
          'sbs-player-ad-newwork-ad-controls'
        );
        if (networkControls) {
          networkControls.visible = false;
          console.log(
            `#### AdWrapper - Network ad controls hidden for ${platformName} ad`
          );
        }
      } catch (error) {
        console.error(
          `#### AdWrapper - Error hiding network ad controls for ${platformName}:`,
          error
        );
      }
    }
  }
);
